export const API_TOKEN: string = process.env.REACT_APP_API_TOKEN as string;
export const OAUTH_CLIENT_ID: string = process.env.REACT_APP_OAUTH_CLIENT_ID as string;
